// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"7b81476c","6":"b60cda74","94":"6ca941ca","308":"8c6ce4a0","334":"2da29427","732":"06a3bb9c","849":"76817aa8","898":"31d6cfe0","933":"d1dd226d"}[chunkId] + ".chunk.css";
};